
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15710","data-name":"Rectangle 15710","width":"25","height":"25","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_46511","data-name":"Group 46511","transform":"translate(-804 -727)"}},[_c('g',{attrs:{"id":"Group_46502","data-name":"Group 46502","transform":"translate(804 727)"}},[_c('rect',{attrs:{"id":"Rectangle_15709","data-name":"Rectangle 15709","width":"25","height":"25","fill":"none"}}),_c('g',{attrs:{"id":"Group_46494","data-name":"Group 46494"}},[_c('g',{attrs:{"id":"Group_46493","data-name":"Group 46493","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_38732","data-name":"Path 38732","d":"M4.481 9.056A9.323 9.323 0 002.434 12.5 10.426 10.426 0 0012.5 19.339a11.456 11.456 0 002.863-.36M6.728 7.237A11.191 11.191 0 0112.5 5.661 10.426 10.426 0 0122.566 12.5a9.731 9.731 0 01-4.294 5.265M6.728 7.237L3.5 4.293m3.228 2.944l3.65 3.328m7.894 7.2l3.228 2.942m-3.228-2.944l-3.649-3.328m0 0a2.574 2.574 0 000-3.869 3.211 3.211 0 00-4.244 0m4.243 3.868l-4.242-3.867","fill":"none","stroke":"#8d97a1","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])])])])
          )
        }
      }
    